import React from 'react';

export default function About() {
  return (
    <div>
      <div className='page'>
        <div className='about_Container'>
          <div className='box1'>
            <h1 className='pagetitle'>About Me</h1>
            <div className='discription'>Your dedicated personal trainer, committed to transforming lives through fitness, one rep at a time.</div>
            <div className='button'>Workout with me</div>
          </div>
          <div className='box2'>
            <img className='models2' src='/images/grey girl.jpg' alt='Models2' />
            <img className='models3' src='/images/asian-woman-doing-exercises.jpg' alt='Models2' />
          </div>
        </div>
        <div className='about_Container2'>
          <div className='left_box'>
            <div className='image-container'>
              <img className='models4' src='/images/girl-stadium-is-playing-sports.jpg' alt='Models4' />
            </div>
          </div>
          <div className='right_box'>
            <div className='exp_card'>
              <h1 className='pagetitle'>Over 8 Year Of Experience</h1>
            </div>
            <div class="discription">
              Perfecting Fitness Techniques <br></br>
              Science-Backed Methods, Time-Tested Results <br></br>
              Where Experience Meets Exceptional Transformation
            </div>
            <div className='button'>JOIN NOW</div>
          </div>
        </div>
        <div className='about_Container3'>
          <div className='box3'>
            <div class="pagetitle">achievements</div>
            <div className='discription'>
              Transforming 5,000+ members through personalized fitness journeys. Our proven methods deliver real results that last beyond the gym walls.
            </div>
            <div class="achievement-points">
              <div class="bullet-item">
                <span class="equipment-bullet">🏋️</span>
                <span>8 Years Building Stronger Communities</span>
              </div>
              <div class="bullet-item">
                <span class="equipment-bullet">⏱️</span>
                <span>24/7 Premium Facility Access</span>
              </div>
              <div class="bullet-item">
                <span class="equipment-bullet">🧠</span>
                <span>Science-Backed Training Methods</span>
              </div>
              <div class="bullet-item">
                <span class="equipment-bullet">⭐</span>
                <span>Award-Winning Fitness Programs</span>
              </div>
            </div>
          </div>
          <div className='box4'>
            <div className='card1'>
              <div class="count">8</div>
              <div class="title">Year of Health Coaching Experience</div>
            </div>
            <div className='card1'>
              <div class="count">47</div>
              <div class="title">Happy Customer with Reference</div>
            </div>
          </div>
          <div className='box5'>
            <div className='card1'>
              <div class="count">12</div>
              <div class="title">Contest and Confer Attended</div>
            </div>
            <div className='card1'>
              <div class="count">90</div>
              <div class="title">Day of a new Superfast Program</div>
            </div>
          </div>
        </div>
        <div className='about_Container4'>
          <div className='box6'>
            <div class="pagetitle">Start changing your life now</div>
            <div class="discription">
              Start changing your life today.
              Your stronger tomorrow begins now.
            </div>
            <div className='button'>Contact Right Now</div>
          </div>
          <div className='box7'>
            <img className='models1' src='/images/bodybuilder-during-bicep.png' alt='Models1' />
          </div>
        </div>
      </div>
    </div>
  );
}
